import StepImage from "../../../../../../assets/images/scene_2.png";

import styles from "./stepthree.module.scss";

const StepThree = () => {
  return (
    <div className={styles.StepThree}>
      <div className={styles.ImageContainer}>
        <img src={StepImage} alt="" />
      </div>
      <div className={styles.Content}>
        <p className={styles.Title}>
          <strong>Banking</strong> that Advances your life
        </p>
        <p className={styles.SubTitle}>
          We believe banking should be able to help you progress
        </p>
      </div>
    </div>
  );
};

export default StepThree;
